import { fade } from "@material-ui/core/styles/colorManipulator";

export const styles = theme => ({
  btnGroupContainer: {
    boxShadow: `0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)`
  },
  btnRoot: {
    color: "#263238",
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "16px",
    paddingRight: "16px",
    fontSize: "14px",
    minWidth: "64px",
    // transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    // border-top-right-radius: 4px;
    // border-bottom-right-radius: 4px;
    // letter-spacing: 0.02857em;
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "#ffffff"
  },
  calendarIcon: {
    marginRight: theme.spacing(1)
  },
  nonActiveDatePicker: {
    cursor: "default",
    pointerEvents: "none",
    color: "#C5C5C5"
  }
});
